/**
 * ScheduleDraft delete mutation hook.
 */

import { useMutation, useQueryClient } from "react-query";
import { scheduleDraftQueryKeys } from "./queryKeys";
import { scheduleDraftDataService } from "../services/scheduleDraftDataService";

export function useDeleteScheduleDraft(options = {}) {
    const queryClient = useQueryClient();

    return useMutation(
        (draftId) => scheduleDraftDataService.deleteDraft(draftId),
        {
            onSuccess: async (...args) => {
                await queryClient.invalidateQueries(scheduleDraftQueryKeys.all);
                if (options.onSuccess) {
                    await options.onSuccess(...args);
                }
            },
            ...options,
        },
    );
}

export default useDeleteScheduleDraft;
